export default __webpack_public_path__ + "static/logo-v-7a7e29898644726b81ec28d57ea8ae58.svg";